import {
Home,
  Building2,
  Hammer,
  RefreshCcw,
  Landmark,
  BadgePercent,
  Clock3,
  Percent,
  FileCheck2,
  Users,
  Wallet,
  Briefcase,
  User,
  IndianRupee,
  CalendarDays,
  IdCard,
  BadgeCheck,
  PhoneCall,
  ClipboardList,
  ShieldCheck,
  FileSearch,
  FileText
} from "./icons";

export const process = {
  badge: "Loan Journey",

  items: [
    {
      icon: ClipboardList,
      title: "Submit Your Enquiry",
      description:
        "Fill out a simple enquiry form or speak with our loan advisors to get started.",
    },
    {
      icon: PhoneCall,
      title: "Free Expert Consultation",
      description:
        "Our experts understand your requirements and evaluate your eligibility.",
    },
    {
      icon: Landmark,
      title: "Compare Loan Offers",
      description:
        "We compare multiple banks and NBFCs to find the most suitable loan for you.",
    },
    {
      icon: FileCheck2,
      title: "Documentation & Verification",
      description:
        "We help you complete documentation and coordinate with the lender for verification.",
    },
    {
      icon: BadgeCheck,
      title: "Loan Approval",
      description:
        "After successful verification, your loan application is approved by the lender.",
    },
    {
      icon: Wallet,
      title: "Loan Disbursement",
      description:
        "Funds are disbursed directly as per the lender's process so you can move ahead with confidence.",
    },
  ],
};

export const whyMoneyMartItems = [
  {
    icon: Building2,
    title: "Compare Multiple Banks",
    description:
      "One application gives you access to loan offers from leading banks and NBFCs, helping you choose the option that best matches your profile.",
  },
  {
    icon: BadgePercent,
    title: "Competitive Interest Rates",
    description:
      "We help you compare interest rates, processing charges, repayment tenures, and lender benefits so you can make an informed decision.",
  },
  {
    icon: Users,
    title: "Dedicated Loan Expert",
    description:
      "A dedicated relationship manager guides you through the entire process—from application to loan disbursement.",
  },
  {
    icon: FileCheck2,
    title: "Documentation Assistance",
    description:
      "Our team reviews your documents beforehand, reducing the chances of delays or avoidable queries from the lender.",
  },
  {
    icon: Clock3,
    title: "Faster Processing",
    description:
      "With an organized application and continuous follow-up, we help make the approval process smoother and more efficient.",
  },
  {
    icon: ShieldCheck,
    title: "Transparent Guidance",
    description:
      "We explain the available loan options, eligibility requirements, charges, and repayment terms so you can make confident decisions.",
  },
];

export const ctaFeatures = [
  {
    icon: Building2,
    title: "Multiple Lenders",
    description: "Compare loan offers from leading Banks & NBFCs.",
  },
  {
    icon: Users,
    title: "Dedicated Loan Expert",
    description: "Personalized assistance from enquiry to disbursement.",
  },
  {
    icon: ShieldCheck,
    title: "Transparent Guidance",
    description: "Clear advice with complete documentation support.",
  },
];

export const leadFormHighlights = [
    "20+ Years of Loan Advisory Experience",
    "25+ Leading Banks & NBFC Partners",
    "Dedicated Relationship Manager",
    "Complete Documentation Support",
    "Transparent & Hassle-Free Process",
  ];